// extracted by mini-css-extract-plugin
export default {"modifyPassword":"modifyPassword-P0U3c","modifyPasswordBtns":"modifyPassword-btns-RkcRR"};